<template>
    <div class="home">
        <!-- ---------------------------遊戲Banner開始--------------------------- -->
        <header class="cm-banner" id="cm-banner">
            <div
                id="cm-carousel-indicators"
                class="carousel slide"
                data-ride="carousel"
            >
                <ol class="carousel-indicators py-3">
                    <li data-target="#cm-carousel-indicators" data-slide-to="0"></li>
                    <li data-target="#cm-carousel-indicators" data-slide-to="1"></li>
                </ol>

                <div class="carousel-inner" role="listbox">
                    <!--此段由JS渲染
                    <div class="carousel-item">
                        <img class="d-block w-100" src="@/assets/images/home/banner001.jpg">
                    </div>
                    <div class="carousel-item">
                        <img class="d-block w-100" src="@/assets/images/home/banner002.jpg">
                    </div>
                    -->
                </div>

                <a
                    class="carousel-control-prev"
                    href="#cm-carousel-indicators"
                    role="button"
                    data-slide="prev"
                >
                    <span
                        class="carousel-control-prev-icon bg-dark rounded-left"
                        aria-hidden="true"
                    ></span>
                </a>
                <a
                    class="carousel-control-next"
                    href="#cm-carousel-indicators"
                    role="button"
                    data-slide="next"
                >
                    <span
                        class="carousel-control-next-icon bg-dark rounded-right"
                        aria-hidden="true"
                    ></span>
                </a>
            </div>
        </header>
        <!-- ---------------------------遊戲Banner結束--------------------------- -->
        <!-- ----------------------------遊戲介紹開始---------------------------- -->
        <section class="pt-3 cm-game-section">
            <HomeContent :ismore="false" :content="infos"/>
        </section>
        <!-- -----------------------------遊戲介紹結束----------------------------- -->
        <!-- -----------------------------更多遊戲開始----------------------------- -->
        <section class="pt-3 cm-game-section cm-game-showmoregame">
            <HomeContent :ismore="true" :content="infos"/>
        </section>
        <!-- -----------------------------更多遊戲結束----------------------------- -->
        <MoreGamesEnd></MoreGamesEnd>
    </div>
</template>


<script>
// // @ is an alias to /src
import $ from "jquery";
import axios from "axios";
import * as BackendSetting from "@/assets/js/util/BackendSetting.js";
import eventBus from '@/assets/js/event/EventBus.js'
import store from "@/store/store-controller/store.js";
import HomeContent from "@/components/HomeContent.vue";
import MoreGamesEnd from "@/components/MoreGamesEnd.vue";
import { cm_banner_video_dynamic_size } from "@/assets/js/cm-banner-video";
import { cm_title_container_dynamic_height } from "@/assets/js/cm-game";

export default {
    name: "home",
    components: {
        HomeContent,
        MoreGamesEnd
    },
    data() {
        return {
            carouselBannerHtml: "",
            carouselIindicatorsHtml: "",
            defaultCarouselBanner: [ // default carousel banner
                {fileType:"image", imageFile:require("@/assets/images/home/banner001.jpg")},
                {fileType:"image", imageFile:require("@/assets/images/home/banner002.jpg")}
            ],
            bannerVideoUrlObj: {}, // {elementId: url}
            infos: ""
        };
    },
    created() {
        window.addEventListener("resize", this.handleResize);
    },
    mounted() {
        // 初始化
        this.init(this.$i18n.locale);

        // 更換語言時
        const self = this;
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_HOME, function(i18n) {
            self.init(i18n.locale);
        });

        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_SWITCH_PAGE_SHOW_ITEMS , false);

        // 驗證是否為登入狀態，未登入狀態則顯示loginModal讓玩家登入，玩家登入完畢後再回來
        if(this.$route.query.action == "login") {
            // 驗證是否為登入狀態
            let verifySetting = {
                verifyStatus: true, // 驗證登入
                from: process.env.VUE_APP_ROUTER_HOME, // 來源頁面
                setFrontendRouterPushCookie: false, // 是否設置cookie方便登入會導回from設置的頁面
                showLoginModal: true // 未登入狀態下顯示loginModal
            };
            eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_VERIFY_LOGIN, verifySetting);
        }
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        async init(i18nLocale) {
            // 清空carousel banner
            this.bannerVideoUrlObj = {};

            // default carousel banner
            this.setCarouselBannerHtml(this.defaultCarouselBanner);

            //  依照語系向後端取資料
            const carouselBannerArray = await BackendSetting.getCarouselBanner(i18nLocale);
            if(Array.isArray(carouselBannerArray) && carouselBannerArray.length > 0) { // ajax成功
                // 重設carousel banner
                this.setCarouselBannerHtml(carouselBannerArray);
            }

            // Video
            cm_banner_video_dynamic_size();

            //遊戲介紹
            this.infos = "";
            this.getHomeInfo();
        },
        setCarouselBannerHtml(carouselBannerArray) {
            this.carouselBannerHtml = "";
            this.carouselIindicatorsHtml = "";
            this.bannerVideoUrlObj = (carouselBannerArray.length > 0 ? {} : this.bannerVideoUrlObj); // 確認API有傳banner資料，將原本預設內容清空

            for(let i=0; i<carouselBannerArray.length; i++) {
                const carouselBanner = carouselBannerArray[i];
                let addCarouselIindicator = false;

                if(carouselBanner.fileType=="video") {
                    // Video
                    const elementId = "carousel-movie" + i;
                    this.carouselBannerHtml += `
                        <div class="carousel-item">
                            <video class="carousel-movie" playsinline autoplay loop muted="muted">
                                <source
                                    src="${carouselBanner.fileUrl}"
                                    type="video/mp4"
                                >Your browser does not support the video tag.
                            </video>
                        </div>
                    `
                    addCarouselIindicator = true;
                    this.bannerVideoUrlObj[elementId] = carouselBanner.fileUrl;
                }
                else if(carouselBanner.fileType=="image") {
                    this.carouselBannerHtml += `
                        <div class="carousel-item">
                            <img class="d-block w-100" src=${carouselBanner.imageFile}>
                        </div>
                    `
                    addCarouselIindicator = true;
                }

                if(addCarouselIindicator) {
                    this.carouselIindicatorsHtml += `
                        <li data-target="#cm-carousel-indicators" data-slide-to="${i}"></li>
                    `;
                }
            }

            // 將carousel banner顯示於頁面上
            if(this.carouselBannerHtml!="" && this.carouselIindicatorsHtml!="") {
                $(".carousel > .carousel-inner").empty();
                $(".carousel > .carousel-inner").append(this.carouselBannerHtml);
                $(".carousel > .carousel-indicators").empty();
                $(".carousel > .carousel-indicators").append(this.carouselIindicatorsHtml);
                this.carouselBannerOnLoad();
            }
        },
        carouselBannerOnLoad() {
            // carousel banner
            $('.carousel-item').first().addClass('active');

            // 圓鈕
            $('.carousel-indicators > li').first().addClass('active');
            
            // 停止輪播
            $(".carousel").carousel({ interval: 0 });

            // 滑動事件
            $(".carousel").on("slid.bs.carousel", function() {
                // 判斷carousel banner中有影片則動態調整影片寬高
                const element = document.querySelector(".carousel-item .carousel-movie");
                if (element != null) {
                    // Video
                    cm_banner_video_dynamic_size();
                }
            });
        },
        handleResize() {
            // 依照瀏覽器寬度計算出Video影片容器的高度，讓Video影片可以無黑邊滿版撥放
            cm_banner_video_dynamic_size();
        },
        getHomeInfo()
        {
            let self = this;
            let bodyFormData = new FormData();
            bodyFormData.append('languageCode', store.getters['storeI18n/getNowLanguage']);
            bodyFormData.append('ConditionBelong','NewCMHome');
            bodyFormData.append('ConditionCategory','activity');
            axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getGamesInfoAction.shtml",
                data: bodyFormData,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
            })
            .then(function(response) {
                self.infos = response;
                
                // Video
                cm_banner_video_dynamic_size();
            });
        }
    }
};
</script>